// istanbul ignore file — composition shell; logic lives in hooks, slices, and child modules.

import { useNewCode } from '@calendly/feature-check-react';
import { usePageTitle } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { AddMiniIcon, QuestionCircleIcon } from '@calendly/ui/components/icons';
import { PageHeader } from '@calendly/ui/components/page-header';
import { TitleText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { Container } from 'components/organizations/layout';
import { LearnMoreButton } from 'components/page_elements';
import { useSettingsModalEmbed } from 'components/settings_modal_embed_context';
import { useContextualHelp } from 'features/contextual_help';
import { isUserGroupsEnabledSelector } from 'features/user_groups/slice';
import { isAdminOrOwnerSelector } from 'selectors/current_user';
import { List } from './list';
import { NewUserGroupButton } from './new_user_group_button';
import { isAvailableFeatureSelector } from '../../billing';
import { CONTENT_PAGES } from '../../empty_state';
const headerContainerCss = "h151en2h";
const HeaderContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerContainerCss, props.className)} />;
});
export const Page = () => {
  const inSettingsModal = useSettingsModalEmbed();
  usePageTitle(I18n.t('publisher.admin.groups.title'));
  const useNewEmptyState = useNewCode('activation_q3')?.enabled;
  const isFeatureAvailable = useSelector(state => isAvailableFeatureSelector(state, {
    featureKey: 'user_groups'
  }));
  const isUserGroupsEnabled = useSelector(isUserGroupsEnabledSelector);
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector);
  const {
    open: openContextualHelp
  } = useContextualHelp();
  const onClickLearnMore = () => {
    openContextualHelp({
      contentKey: CONTENT_PAGES.groups
    });
  };
  return <>
      {!inSettingsModal && <HeaderContainer>
          <PageHeader eyebrow={<TitleText variant="eyebrow">
                {I18n.t('publisher.admin.navigation.people')}
              </TitleText>} title={I18n.t('publisher.admin.groups.title')} protip={useNewEmptyState && <LearnMoreButton onClick={onClickLearnMore} aria-label={I18n.t('publisher.contextual_help.page_title.groups_overview')}>
              <QuestionCircleIcon />
            </LearnMoreButton>} actions={[useNewEmptyState && <NewUserGroupButton key="new-user-group-button" text={I18n.t('publisher.empty_state.groups.primary_button')} decoration="secondary-outline" disabled={!isFeatureAvailable}>
                  <AddMiniIcon />
                </NewUserGroupButton>, isAdminOrOwner && !useNewEmptyState && <NewUserGroupButton key="new-user-group" disabled={!isUserGroupsEnabled} />].filter(Boolean)} />
        </HeaderContainer>}
      <Container newAdminIALayout>
        <List />
      </Container>
    </>;
};

require("./page.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./page.js");